import { render, staticRenderFns } from "./SectionGroup.vue?vue&type=template&id=f833fc50&scoped=true"
import script from "./SectionGroup.vue?vue&type=script&lang=js"
export * from "./SectionGroup.vue?vue&type=script&lang=js"
import style0 from "./SectionGroup.vue?vue&type=style&index=0&id=f833fc50&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f833fc50",
  null
  
)

export default component.exports